import appHeaderNew from '@/components/app/app-header/app-header-new.vue';

export default {
  components: {
    appHeaderNew,
  },
  data() {
    return {
      toggled: false,
      value: 10,
      updateValue: 22,
    };
  },
  methods: {
    onClick() {
      this.value = this.updateValue;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/debug/debug.js